/*
  Size chart bottom sheet — mobile swipe-to-close.
  Open/close/Escape/outside-click behaviour comes from the theme's
  <tool-tip> component in theme.js; this only adds the drag gesture
  on the size-chart context sheet for viewports <= 768px.
*/
(function () {
  'use strict';

  if (window.__sizeChartSheetInit) return;
  window.__sizeChartSheetInit = true;

  var DISMISS_DISTANCE = 80;
  var startX = 0;
  var startY = 0;
  var deltaY = 0;
  var axis = null;
  var dragging = false;
  var sheet = null;
  var tip = null;

  function openMobileSheet() {
    if (window.innerWidth > 768) return null;
    return document.querySelector(
      'tool-tip[data-tool-tip="size-chart"][data-tool-tip-open="true"]'
    );
  }

  document.addEventListener(
    'touchstart',
    function (e) {
      tip = openMobileSheet();
      if (!tip) return;

      sheet = tip.querySelector('.tool-tip__inner');
      if (!sheet || !sheet.contains(e.target)) return;

      // Let vertically scrolled content scroll back up instead of dragging
      var content = tip.querySelector('.tool-tip__content');
      if (content && content.contains(e.target) && content.scrollTop > 0) return;

      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      deltaY = 0;
      axis = null;
      dragging = true;
      sheet.style.transition = 'none';
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!dragging || !sheet) return;

      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      // Horizontal gesture (e.g. scrolling the table) — release the sheet
      if (axis === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'x') {
          dragging = false;
          sheet.style.transition = '';
          return;
        }
      }

      deltaY = Math.max(0, dy);
      sheet.style.transform = 'translateY(' + deltaY + 'px)';
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function () {
      if (!dragging || !sheet) return;
      dragging = false;
      sheet.style.transition = '';
      sheet.style.transform = '';

      if (deltaY > DISMISS_DISTANCE && tip) {
        var closeButton = tip.querySelector('[data-tool-tip-close]');
        if (closeButton) closeButton.click();
      }
      deltaY = 0;
    },
    { passive: true }
  );
})();
